<app-nav-pages></app-nav-pages>

<main>
  <section class="founder-story-section">
    <div class="founder-top-band">
      <p class="founder-title">OUR FOUNDER'S STORY</p>
    </div>
    <div class="founder-story-content">
      <div class="founder-image-stack">
        <span class="image-glow"></span>
        <img src="assets/imgs/ceo-leadership-pic.jpg" alt="Lucky R. Erherha" class="founder-image">
      </div>
      <div class="founder-copy">
        <p class="founder-paragraph">
          I grew up in a small community in Edo State, where I first learned to dream beyond the limits of my environment and embrace the dignity of meaningful work. Those early years shaped my character and sharpened the skills that would later define my journey.
        </p>
        <p class="founder-paragraph">
          By divine providence, my path expanded far beyond that humble beginning. I travelled across West world, lived in first-world cities, and encountered development at a level that redefines how people live, work, and aspire to become their best selves. That exposure did more than open my eyes; it became the fire for my purpose.
        </p>
        <p class="founder-paragraph">
          Everywhere I went, I saw Africans rising to remarkable heights once they were given structure, support, and functional environments. Their talent, drive, and resilience became undeniable proof that our potential has never been the problem, our environment has.
        </p>
        <p class="founder-paragraph founder-realization">
          That realization reshaped everything.
        </p>
        <p class="founder-paragraph">
          I left the comfort of developed cities with a renewed conviction that Africa can match and surpass the best of the world. Our people do not need to leave their continent to express their fullest potential, experience opportunity, and first-world living. What we need is the right foundation: infrastructure, structure, and vision that empower the greatness already within us.
        </p>
        <p class="founder-italic-return">This is why I returned.</p>
        <p class="founder-italic-build">This is why I build.</p>
        <p class="founder-mission-intro">This is the mission that defines my work:</p>
        <p class="founder-mission-text">To bring first-world development to African cities, starting with Nigeria.</p>
        <a href="https://www.luckyerherha.com/" target="_blank" rel="noopener noreferrer" class="founder-read-more-btn">
          <span>Read More</span>
          <span><svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="16"
              viewBox="0 0 13 16"
              fill="none"
            >
              <path
                d="M1.00006 14.2611L9.95122 0.999263L1.00006 14.2611ZM9.95122 0.999263L11.5677 9.32914L9.95122 0.999263ZM9.95122 0.999263L1.62134 2.61577L9.95122 0.999263Z"
                fill="white"
              />
              <path
                d="M1.00006 14.2611L9.95122 0.999263M9.95122 0.999263L11.5677 9.32914M9.95122 0.999263L1.62134 2.61577"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg></span>
        </a>
      </div>
    </div>
  </section>
</main>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
